import { useStores } from '@src/Common/Hooks/useStores';
import ButtonArrow from '@src/Components/Atoms/ButtonArrow/ButtonArrow';
import ButtonDefault from '@src/Components/Atoms/ButtonDefault/ButtonDefault';
import React from 'react';
import styles from './TimelineEmptyData.module.scss';

const TimelineEmptyData = () => {
  const { AdvanceFilterStore, DUMEventStore } = useStores();
  return (
    <div
      id="timeline-wrapper"
      data-testid="timeline-empty-data"
      className={styles['timeline-wrapper'] + ' ' + styles['NoData']}
    >
      <div className={styles['NoDataContainer']}>
        <div className={styles['TextContainer']}>
          <h1>No Data</h1>
          <p>Filter Result 0</p>
        </div>
        <ButtonDefault
          label="Reset Filter"
          onClick={() => {
            AdvanceFilterStore.resetFilter();
            DUMEventStore.refetchData();
            AdvanceFilterStore.show = true;
          }}
        />
        <div className={styles['SliderContainer']}>
          <ButtonArrow
            type="double"
            rotation="left"
            isDisabled={true}
            onClick={() => {
              //
            }}
          />
          <ButtonArrow
            type="default"
            rotation="left"
            isDisabled={true}
            onClick={() => {
              //
            }}
          />
          <p>{AdvanceFilterStore.filters.year.from}</p>
          <div className={styles['line']} />
          <p>{AdvanceFilterStore.filters.year.end}</p>
          <ButtonArrow
            type="default"
            rotation="right"
            isDisabled={true}
            onClick={() => {
              //
            }}
          />
          <ButtonArrow
            type="double"
            rotation="right"
            isDisabled={true}
            onClick={() => {
              //
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TimelineEmptyData;
